var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.1 5.8a2.2 2.2 0 0 0-1.55-1.56C15.18 3.88 10 3.88 10 3.88s-5.18 0-6.55.36A2.2 2.2 0 0 0 1.9 5.8C1.54 7.18 1.54 10 1.54 10s0 2.82.36 4.2a2.2 2.2 0 0 0 1.55 1.56c1.37.36 6.55.36 6.55.36s5.18 0 6.55-.36a2.2 2.2 0 0 0 1.55-1.56c.36-1.38.36-4.2.36-4.2s0-2.82-.36-4.2ZM8.3 12.6V7.4l4.5 2.6-4.5 2.6Z",
  fill: "white"
})));
export default SvgYoutube;